export const SECTION_INFORMATION = 'information';
export const SECTION_GMC_INFORMATION = 'gmcInformation';
export const SECTION_RMC_INFORMATION = 'rmcInformation';
export const SECTION_BREEDS = 'breeds';
export const SECTION_TEAM = 'team';

export const SECTION_PRODUCT_FEATURES = 'productFeatures';
export const SECTION_FEEDING_GUIDES = 'feedingGuides';
export const SECTION_BRANDING = 'branding';
export const SECTION_PACKAGING_FEATURES = 'packagingFeatures';
export const SECTION_OTHER_LEGAL_ELEMENTS = 'otherLegalElements';
export const SECTION_LEGAL_TEXT_SUB_HEADING = 'otherLegalElements';
export const SECTION_PRODUCT_MEDIA = 'productMedia';
export const SECTION_COMMERCIAL_LABEL = 'commercialLabel';
export const SECTION_BUCKET = 'bucket';
export const SECTION_NUTRITIONAL_LEGAL_ELEMENTS = 'nutritionalLegalElements';
export const SECTION_COMPOSITIONS = 'compositions';
